<template>
<div>
    <div class="ibox animated fadeInRightBig">
        <div class="ibox-title">
            <h3>Editar Cargo <i class="fa fa-address-card-o" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
        </div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="name"><span class="required">*</span> Nome do Cargo</label>
                        <input type="text" class="form-control" name="name" v-model="role.name" id="name">
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/roles" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                role: {
                    name: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'roles/' + id;

                self.$http.put(api, self.role)
                    .then((response) => {
                        self.$message('Sucesso', `Cargo atualizado com sucesso`, 'success');
                        this.$router.push('/roles');
                    })


                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getRole(){
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'roles/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.role = response.data.data[0];
                    })
                    .catch((error) => {
                       self.$message(null, 'Ocorreu um erro ao buscar as informações do Cargo', 'error');
                    });
            }
        },
        mounted: function(){
            this.getRole();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Role/Edit.vue